import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { Grid } from '@material-ui/core';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.Grid}`,
  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  backgroundColor: 'transparent'
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    {...props}
  />
))(({ theme }) => ({
  color: '#595959',
  flexDirection: 'row',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(-1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(1),
  borderTop: '1px solid rgba(0, 0, 0, 0)',

}));

export default function PreguntasFrecuentes() {
  const accordionData = [
    {
      title: '¿Qué es un bróker?',
      content: 'Es el intermediario entre la aseguradora y el cliente'
    },
    {
      title: '¿Cómo funciona INTER?',
      content: 'Somos una plataforma digital en la que podrás encontrar la mayor cobertura, al menor precio con las mejores aseguradoras.'
    },
    {
      title: '¿Dónde puedo ver mis pólizas?',
      content: 'En nuestra App inter.mx llevar tus pólizas contigo nunca fue tan fácil y seguro.'
    },
    {
      title: 'Tuve un accidente ¿A donde me comunico?',
      content: 'Deberás comunicarte con la aseguradora para reportar el siniestro. Posteriormente, un ajustador llegará hasta tu ubicación para evaluar los daños, ' +
        'investigar los hechos y determinar el pago de los daños correspondientes. En caso de que no encuentres el número de la aseguradora podrás contactarte a nuestro call center 55 442 46837.'
    },
  ]
  const [expanded, setExpanded] = useState('');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <div className="textPF">
        Preguntas frecuentes
      </div>
      <div style={{ paddingTop: '20px' }}>
        {
          accordionData.map((title, content) => {
            return (
              <Accordion
                key={content}
                expanded={expanded === `panel${content}`}
                onChange={handleChange(`panel${content}`)} >
                <AccordionSummary
                  expandIcon={expanded === `panel${content}` ? <RemoveIcon /> : <AddIcon />}
                  aria-controls={`panel${content}d-content`} id={`panel${content}d-header`}
                >
                  <Typography>{title.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography >{title.content}</Typography>
                </AccordionDetails>
              </Accordion>)
          })
        }
      </div>
    </Grid>
  );
}
